import * as React from "react"

const ExclamationTriangle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M9 .7a1.2 1.2 0 0 0-2 0L.2 12a1.2 1.2 0 0 0 1 1.8h13.6a1.2 1.2 0 0 0 1-1.8L9 .7Zm-1 .5 7 11.4a.1.1 0 0 1-.2.2H1.2a.1.1 0 0 1-.1-.2L7.9 1.2Zm-.7 3.6a.7.7 0 1 1 1.4 0L8.6 9a.6.6 0 0 1-1.2 0l-.1-4.3Zm1.5 6.4a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0Z" />
  </svg>
)

export default ExclamationTriangle
